import {closeModal, openModal, pathIs, polishPlurals, url} from "../../../utilities";
import {toastAlert} from "../../../toastAlert";
import moment from "moment";
import {confirmModal} from "../../../confirmModal";
import Spinner from "../../../spinner";
import {getItemName, getItemQuantity, getItemUnit, isAnimalItem} from "./invoice_items";
import * as Constants from "../constants";
import axios from "axios";
import {emptyForm, fillFormInputs, handleApiForm, hideField, showField} from "../../../forms";
import {users_and_entities} from "./users_and_entities";
import {naturalSort} from "../../../datatables/dataTables.naturalSorting";

const uuid = require('uuid/v4');

export const invoices_page = () => {
    if (pathIs(['/app/reckonings/invoices/add', '/app/reckonings/invoices/*/edit'])) {
        const body = $('body');

        const form = $('#addInvoice, #editInvoice');

        let editing = false;
        if(form.attr('id') === 'editInvoice') {
            editing = true;
        }

        const typeNode = form.find("select[name='type']");
        const collectionCentreNode = form.find("select[name='collection_centre_id']")
        const priceListTypeNode = form.find('select[name="price_list_type"]');
        const userNode = form.find('select[name="user_id"]');

        // Animals table
        let data = JSON.parse(window._data ?? '[]');
        let collectionCentres = JSON.parse(window._collectionCentres ?? '[]');
        let itemsData = JSON.parse(window._itemsData ?? '[]');

        let items = [];
        let availableData = () => {
            return data.filter(el => !items.find(r => r.id === el.id && r.type === el.type));
        }

        let entitiesData = JSON.parse(window._entitiesData ?? '[]');

        let entities = {
            data: entitiesData ?? [],
            current: null
        };
        users_and_entities(entities, entitiesDataUpdated);

        let oldType = parseInt(typeNode.val());
        let oldCollectionCentre = parseInt(collectionCentreNode.val());
        let oldPriceListType = parseInt(priceListTypeNode.val());
        let intendedUse = 0;
        let priceListType = priceListTypeNode.val();
        let userId = userNode.val();

        let userChanged = false;

        if (userId.startsWith('entity-')) {
            let entity = entities.data.find(el => parseInt(el.id) === parseInt(userId.replace('entity-', '')));
            if (entity) {
                entities.current = entity;
            }
        }

        function updateQualityChosen(row = null) {
            if (data.length > 0) {
                for (let el of data) {
                    if (row !== null) {
                        if (parseInt(el.id) !== parseInt(row.id) && el.type === row.type) {
                            continue;
                        }
                    }

                    let check = true;
                    if (typeof el.quality_chosen != 'undefined') {
                        if (parseInt(el.quality_chosen) === 1 && getPrices(el).price_1_class) {
                            check = false;
                        } else if (parseInt(el.quality_chosen) === 2 && getPrices(el).price_2_class) {
                            check = false;
                        }
                    }

                    if (check) {
                        if (getPrices(el).price_1_class) {
                            el.quality_chosen = 1;
                        } else if (getPrices(el).price_2_class) {
                            el.quality_chosen = 2;
                        } else {
                            el.quality_chosen = null;
                        }
                    }

                    if (row !== null) {
                        return row;
                    }
                }
            }
        }

        let table = $('#animalsTable').DataTable({
            stateSave: false,
            columnDefs: [
                {
                    targets: Constants.ANIMALS_CHECKBOX_INDEX,
                    data: null,
                    render: function (data, type, row) {
                        let input = $(`<input data-id="${row.id}" data-type="${row.type}" type="checkbox" class="form-check-input" name="animal[]"/>`);
                        let span = $('<span class="input-wrapper"></span>').append(input);

                        let can = canItemBeSelected(row);

                        if (!can.result) {
                            input.attr('disabled', true);
                            span.prop('title', can.reason);
                        }

                        return span.prop('outerHTML');
                    }
                },
                {
                    targets: Constants.ANIMALS_NAME_INDEX,
                    data: 'name',
                },
                {
                    targets: Constants.ANIMALS_QUANTITY_INDEX,
                    data: 'quantity',
                },
                {
                    targets: Constants.ANIMALS_DATE_INDEX,
                    data: 'date',
                    render: (data) => {
                        return moment(data, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
                    }
                },
                {
                    targets: Constants.ANIMALS_HUNTER_INDEX,
                    data: 'hunter',
                },
                {
                    targets: Constants.ANIMALS_COLLECTION_CENTRE_INDEX,
                    data: 'collection_centre',
                    render: (data, type, row) => {
                        if (data === null) {
                            return '-';
                        }

                        return `<span data-collection_centre_id="${row.collection_centre_id}">${data}</span>`;
                    }
                },
                {
                    targets: Constants.ANIMALS_NUMBER_MP_INDEX,
                    data: 'number_mp',
                    defaultContent: '-'
                },
                {
                    targets: Constants.ANIMALS_DISTRICT_INDEX,
                    data: 'district',
                },
                {
                    targets: Constants.ANIMALS_WEIGHT_INDEX,
                    data: 'weight',
                },
                {
                    targets: Constants.ANIMALS_IDENTIFIER_INDEX,
                    data: 'identifier',
                    render: (data) => {
                        return (data && data.length) > 0 ? data : '-';
                    }
                },
                {
                    targets: Constants.ANIMALS_IDENTIFIER_DISTRICT_VETERINARIAN_INDEX,
                    data: 'identifier_district_veterinarian',
                    render: (data) => {
                        return (data && data.length) > 0 ? data : '-';
                    }
                },
                {
                    targets: Constants.ANIMALS_IDENTIFIER_DIRECT_SALE_INDEX,
                    data: 'identifier_direct_sale',
                    render: (data) => {
                        return (data && data.length) > 0 ? data : '-';
                    }
                },
                {
                    targets: Constants.ANIMALS_ACTIONS_INDEX,
                    data: null,
                    render: (data, type, row) => {
                        return `
                            <button class="btn btn-sm btn-primary btnEditAnimal" data-id="${row.id}" data-type="${row.type}" type="button">Edytuj</button>
                        `;
                    }
                }
            ],
            drawCallback: function () {
                let inputs = this.$('span.input-wrapper');
                inputs.each(function () {
                    new bootstrap.Tooltip(this)
                })
            }
        })
        $("#addItems").on('shown.bs.modal', function () {
            table.api().columns.adjust().responsive.recalc()
        })

        function handleCollectionCentreChange() {
            let id = collectionCentreNode.val();
            let text = null;

            if (parseInt(id) !== 0) {
                text = collectionCentreNode.find(`option[value="${id}"]`).text().trim();
            }

            table.api().column(Constants.ANIMALS_COLLECTION_CENTRE_INDEX).search(text ? '^' + text + '|-$' : '', true, false).draw(false);
        }

        function reloadAnimalsTable() {
            let type = typeNode.val();
            if (parseInt(type) === 1 || parseInt(type) === 3) {
                form.find('select[name="user_id"]').closest('.col-12').show();
            } else {
                form.find('select[name="user_id"]').closest('.col-12').hide();
            }

            if (parseInt(type) === 2) {
                collectionCentreNode.closest('.col-12').show();
                table.api().column(Constants.ANIMALS_COLLECTION_CENTRE_INDEX).visible(true);
                table.api().column(Constants.ANIMALS_NUMBER_MP_INDEX).visible(true);
            } else {
                collectionCentreNode.closest('.col-12').hide();
                table.api().column(Constants.ANIMALS_COLLECTION_CENTRE_INDEX).visible(false);
                table.api().column(Constants.ANIMALS_NUMBER_MP_INDEX).visible(false);
            }

            intendedUse = typeToIntendedUse(type);
            table.api().columns().search('');
            table.api().clear().rows.add(availableData().filter(el => parseInt(el.intended_use) === parseInt(intendedUse))).draw();

            if (parseInt(type) === 2) {
                handleCollectionCentreChange();
            }
        }

        reloadAnimalsTable();
        typeNode.change(async function () {
            let type = parseInt($(this).val());

            let result = true;
            if (items.length > 0) {
                if (type === 2 || (oldType === 2)) {
                    let filteredItems = items.filter(i => i.type === Constants.ITEM_TYPE_ITEM);

                    if (filteredItems.length !== items.length) {
                        if (filteredItems.length === 0) {
                            result = await confirmModal('Zmiana na ten rodzaj spowoduje usunięcie wszystkich wybranych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
                        } else {
                            result = await confirmModal('Zmiana na ten rodzaj spowoduje usunięcie niektórych wybranych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
                        }

                        if (result) {
                            items = filteredItems;
                            reloadItemsTable();
                        }
                    }
                }
            }

            if (result) {
                oldType = parseInt($(this).val());
                reloadAnimalsTable();
            } else {
                $(this).val(oldType);
            }
        })

        collectionCentreNode.change(async function () {
            let collectionCentre = parseInt($(this).val());

            let result = true;
            if (items.length > 0) {
                if (collectionCentre !== 0 && collectionCentre !== oldCollectionCentre) {
                    let itemsFromDifferentCollectionCentre = items.filter(r => parseInt(r.collection_centre_id) !== collectionCentre && r.collection_centre_id);

                    if (itemsFromDifferentCollectionCentre.length > 0) {
                        result = await confirmModal('Zmiana miejsca skupu spowoduje usunięcie niektórych wybranych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
                        if (result) {
                            items = items.filter(r => !r.collection_centre_id);
                            reloadItemsTable();
                            reloadAnimalsTable();
                        }
                    }
                }
            }

            if (result) {
                oldCollectionCentre = collectionCentre;
                handleCollectionCentreChange();
            } else {
                $(this).val(oldCollectionCentre);
            }

            let checked = table.api().checkedCheckboxes();
            for (let input of checked) {
                input = $(input);

                let row = input.closest('tr');
                let collection_centre_id = row.find('[data-collection_centre_id]').data('collection_centre_id');

                if (collection_centre_id && parseInt(collectionCentreNode.val()) !== parseInt(collection_centre_id)) {
                    input.prop('checked', false);
                }
            }

        })

        function typeToIntendedUse(type) {
            let result = 0;

            switch (parseInt(type)) {
                case 1:
                    result = 6
                    break;
                case 2:
                    result = 1;
                    break;
                case 3:
                    result = 2
                    break;
                case 4:
                    result = 3
                    break;
            }

            return result;
        }

        let intendedUseNames = [];
        typeNode.find('option').each(function () {
            intendedUseNames[$(this).val()] = $(this).text();
        })

        function updateCarcassesLeft() {
            typeNode.find('option').each(function () {
                let type = $(this).val()
                let intendedUse = typeToIntendedUse(type);

                let carcassesLeft = availableData().filter(el => parseInt(el.intended_use) === parseInt(intendedUse)).length;
                if (carcassesLeft > 0) {
                    $(this).text(intendedUseNames[$(this).val()] + ` (${carcassesLeft} ${polishPlurals('tusza', 'tusze', 'tusz', carcassesLeft)} do rozliczenia)`)
                }
            })
        }

        updateCarcassesLeft();

        function handleQualityClassVisibility() {
            let visible = true;
            if (parseInt(priceListTypeNode.val()) === Constants.PRICE_LIST_FLAT_RATE) {
                visible = false;
            }

            itemsTable.api().column(Constants.ITEMS_QUALITY_INDEX).visible(visible).draw();
        }

        priceListTypeNode.change(async function () {
            priceListType = parseInt($(this).val());

            let result = true;
            if (items.length > 0) {
                if (priceListType !== oldPriceListType) {
                    let disabledItems = items.filter(r => !canItemBeSelected(r).result);
                    if (disabledItems.length > 0) {
                        result = await confirmModal('Zmiana rodzaju cennika spowoduje usunięcie niektórych wybranych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
                        if (result) {
                            items = items.filter(r => disabledItems.findIndex(d => parseInt(d.id) === parseInt(r.id) && d.type === r.type) === -1);
                        }
                    }
                }
            }

            if (result) {
                oldPriceListType = priceListType;
                reloadAnimalsTable();
                reloadItemsTable();
                handleQualityClassVisibility();
            } else {
                $(this).val(oldPriceListType);
            }
        })

        body.on('change', 'input[name="animal[]"]', function () {
            let row = $(this).closest('tr');

            if (parseInt(intendedUse) === 1 && $(this).prop('checked')) {
                let collection_centre_id = row.find('[data-collection_centre_id]').data('collection_centre_id');

                if (collection_centre_id && parseInt(collection_centre_id) !== parseInt(collectionCentreNode.val())) {
                    collectionCentreNode.val(collection_centre_id).change();
                    let collectionCentreOption = collectionCentreNode.find(`option[value="${collection_centre_id}"]`);

                    toastAlert(`Zmieniono miejsce skupu na "${collectionCentreOption.text().trim()}". Kolejność pozycji w tabeli mogły ulec zmianie.`)
                }
            }
        })

        // Items table
        let itemsChosen = JSON.parse(window._itemsChosen ?? '[]');

        let itemsTable = $('#itemsTable').DataTable({
            stateSave: false,
            drawCallback: function () {
                let selects = this.$('select.with-tooltip');
                selects.each(function () {
                    new bootstrap.Tooltip(this)
                })
            },
            columnDefs: [
                {
                    targets: Constants.ITEMS_NAME_INDEX,
                    data: 'name',
                    render: (data, type, row) => {
                        return getItemName(row);
                    }
                },
                {
                    targets: Constants.ITEMS_UNIT_INDEX,
                    data: null,
                    render: (data, type, row) => {
                        return getItemUnit(row, priceListType);
                    }
                },
                {
                    targets: Constants.ITEMS_QUANTITY_INDEX,
                    data: 'quantity',
                    render: (data, type, row) => {
                        return getItemQuantity(row, priceListType);
                    }
                },
                {
                    targets: Constants.ITEMS_PRICE_INDEX,
                    data: null,
                    render: (data, type, row) => {
                        if (!isAnimalItem(row)) {
                            return row.price;
                        }

                        row = updateQualityChosen(row);
                        if (parseInt(priceListType) === Constants.PRICE_LIST_REGULAR) {
                            if (parseInt(row.quality_chosen) === 2) {
                                return getPrices(row).price_2_class;
                            } else {
                                return getPrices(row).price_1_class;
                            }
                        }

                        return getPrices(row).flat_rate;
                    }
                },
                {
                    targets: Constants.ITEMS_QUALITY_INDEX,
                    data: null,
                    render: (data, type, row) => {
                        if (!isAnimalItem(row)) {
                            return 'nie dotyczy';
                        }

                        let title = '';

                        if (!getPrices(row).price_1_class || !getPrices(row).price_2_class) {
                            if (!getPrices(row).price_1_class) {
                                title = 'Cena dla I klasy nie została ustalona';
                            } else {
                                title = 'Cena dla II klasy nie została ustalona';
                            }
                        }

                        let selected = 0;
                        if (typeof row.quality_chosen != 'undefined') {
                            selected = parseInt(row.quality_chosen);
                        }

                        return `
                            <select name="quality" title="${title}" data-id="${row.id}" data-type="${escape(row.type)}" class="form-select form-select-sm with-tooltip">
                                <option ${selected === 1 && 'selected'} value="1" ${getPrices(row).price_1_class ? '' : 'disabled'}>I klasa</option>
                                <option ${selected === 2 && 'selected'} value="2" ${getPrices(row).price_2_class ? '' : 'disabled'}>II klasa</option>
                            </select>
                        `;
                    }
                },
                {
                    targets: Constants.ITEMS_ACTION_INDEX,
                    data: null,
                    render: (data, type, row) => {
                        return `<button data-uuid="${row.uuid ?? ''}" data-id="${row.id}" 
                                        data-type="${row.type}" class="btn btn-sm btn-danger btnDeleteItem" 
                                        type="button">Usuń</button>`
                    }
                }
            ]
        });

        if (itemsChosen.length > 0) {
            for (let chosen of itemsChosen) {
                let item;

                if (isAnimalItem(chosen)) {
                    item = data.find(i => parseInt(i.id) === parseInt(chosen.id) && i.type === chosen.type);
                    items = [...items, {
                        ...item,
                        quality_chosen: chosen.quality,
                        invoice_item_id: chosen.invoice_item_id
                    }];
                } else {
                    item = itemsData.find(i => parseInt(i.id) === parseInt(chosen.id));
                    items = [...items, {
                        ...item,
                        quantity: chosen.quantity,
                        uuid: chosen.uuid,
                        invoice_item_id: chosen.invoice_item_id
                    }];
                }
            }

            if (items) {
                reloadItemsTable()
                reloadAnimalsTable()
            }
        }
        handleQualityClassVisibility();

        function reloadItemsTable() {
            itemsTable.api().clear().rows.add(items).draw();
        }

        $("#btnAddItems").click(function () {
            let checked = table.api().checkedCheckboxes();
            let element;

            for (let input of checked) {
                input = $(input);

                let id = parseInt(input.data('id'));
                let type = input.data('type');

                element = data.find(el => parseInt(el.id) === id && el.type === type);
                if (element) {
                    items = [...items, element];
                }
            }

            if(parseInt(typeNode.val()) === 3 && !editing && !userChanged && element) {
                if(element.hunter_id && element.hunter_id !== '') {
                    userNode.val(element.hunter_id);
                    toastAlert(`Zmieniono nabywcę na ${element.hunter.trim()}.`)
                }
            }

            closeModal($(this).closest('.modal'));
            reloadAnimalsTable();
            reloadItemsTable();
        })

        body.on('click', '.btnDeleteItem', async function () {
            let id = parseInt($(this).data('id'));
            let type = $(this).data('type');
            let uuid = $(this).data('uuid');

            if (await confirmModal('Czy na pewno chcesz usunąć tą pozycję z faktury?', {color: 'danger'})) {
                let index;

                if (uuid.length > 0) {
                    index = items.findIndex(el => el.uuid === uuid);
                } else {
                    index = items.findIndex(el => parseInt(el.id) === id && el.type === type);
                }

                if (index !== -1) {
                    items = items.filter((el, i) => i !== index)
                }

                reloadItemsTable();
                reloadAnimalsTable();
            }
        })

        function getPrices(item) {
            if (isAnimalItem(item)) {

                let collectionCentre = collectionCentres.find(c => parseInt(c.id) === parseInt(item.collection_centre_id));
                if (parseInt(intendedUse) === 1) {
                    if (!collectionCentre) {
                        return {
                            price_1_class: null,
                            price_2_class: null,
                            flat_rate: null,
                        }
                    }

                    let prices = collectionCentre.cc_prices.find(p => parseInt(p.animal_type_id) === parseInt(item.animal_type_id));
                    let ex_prices = '';

                    if(prices) {
                        ex_prices = prices.animal_cc_prices.find(p => parseInt(p.animal_id) === parseInt(item.animal_id));

                        if(ex_prices) {
                            prices.ex_price_1_class = ex_prices.price_1_class;
                            prices.ex_price_2_class = ex_prices.price_2_class;
                            prices.ex_flat_rate = ex_prices.flat_rate;
                        }else{
                            prices.ex_price_1_class = null;
                            prices.ex_price_2_class = null;
                            prices.ex_flat_rate = null;
                        }

                    }

                    return {
                        price_1_class: prices ? (prices.ex_price_1_class ? prices.ex_price_1_class : prices.price_1_class ) : null,
                        price_2_class: prices ? (prices.ex_price_2_class ? prices.ex_price_2_class : prices.price_2_class ) : null,
                        flat_rate: prices ? (prices.ex_flat_rate ? prices.ex_flat_rate : prices.flat_rate ) : null
                    };
                }

                if (entities.current !== null) {
                    let prices = entities.current.be_prices.find(el => parseInt(el.animal_type_id) === parseInt(item.animal_type_id));
                    let ex_prices = '';

                    if(prices) {
                        ex_prices = prices.animal_be_prices.find(p => parseInt(p.animal_id) === parseInt(item.animal_id));

                        if(ex_prices) {
                            prices.ex_price_1_class = ex_prices.price_1_class;
                            prices.ex_price_2_class = ex_prices.price_2_class;
                            prices.ex_flat_rate = ex_prices.flat_rate;
                        }else{
                            prices.ex_price_1_class = null;
                            prices.ex_price_2_class = null;
                            prices.ex_flat_rate = null;
                        }
                    }

                    return {
                        price_1_class: prices ? (prices.ex_price_1_class ? prices.ex_price_1_class : prices.price_1_class ) : null,
                        price_2_class: prices ? (prices.ex_price_2_class ? prices.ex_price_2_class : prices.price_2_class ) : null,
                        flat_rate: prices ? (prices.ex_flat_rate ? prices.ex_flat_rate : prices.flat_rate ) : null
                    }
                }

                return {
                    price_1_class: item.ex_price_1_class ?? item.price_1_class,
                    price_2_class: item.ex_price_2_class ?? item.price_2_class,
                    flat_rate: item.ex_flat_rate ?? item.flat_rate
                }
            } else {
                return {
                    price_1_class: item.price,
                    price_2_class: item.price,
                    flat_rate: item.price,
                };
            }
        }

        function canItemBeSelected(item, _priceListType = priceListType) {
            let result = true;
            let reason = '';

            if (!isAnimalItem(item)) {
                return {result: true, reason: ''};
            }

            if (parseInt(_priceListType) === Constants.PRICE_LIST_REGULAR) {
                if (parseFloat(item.weight) === 0 || !item.weight) {
                    result = false;
                    reason = 'zwierzyna nie posiada wprowadzonej wagi'
                }

                if (!getPrices(item).price_1_class && !getPrices(item).price_2_class) {
                    result = false;
                    reason = 'gatunek nie ma ustalonej ceny w żadnej z klas jakości'
                }
            } else if (parseInt(_priceListType) === Constants.PRICE_LIST_FLAT_RATE) {
                if (!getPrices(item).flat_rate) {
                    result = false;
                    reason = 'gatunek nie ma ustalonej ceny ryczałtowej'
                }
            }

            return {result, reason};
        }

        form.submit(function (e) {
            e.preventDefault();

            let i = 0;
            for (let item of items) {
                $(this).append(`<input type="hidden" name="items[${i}][id]" value="${item.id}" />`)
                $(this).append(`<input type="hidden" name="items[${i}][type]" value="${item.type}" />`)

                if (typeof item.invoice_item_id != 'undefined') {
                    $(this).append(`<input type="hidden" name="items[${i}][invoice_item_id]" value="${item.invoice_item_id}" />`)
                }

                if (isAnimalItem(item)) {
                    let quality = itemsTable.$(`select[name="quality"][data-id="${item.id}"][data-type="${escape(item.type)}"]`).val() ?? null;
                    $(this).append(`<input type="hidden" name="items[${i}][quality]" value="${quality}" />`)
                } else {
                    $(this).append(`<input type="hidden" name="items[${i}][quantity]" value="${item.quantity}" />`)
                    $(this).append(`<input type="hidden" name="items[${i}][uuid]" value="${item.uuid}" />`)
                }

                i++;
            }

            this.submit();
        })

        // Zmiana użytkownika potencjalnie na podmiot
        // addForm.find('select[name="user_id"]').change(function() {
        //     let value = $(this).val();
        //     if(value.startsWith('entity-id'))
        // })

        // Ustawianie domyślnych wartości przy zmianie miejsca skupu
        let btnSetPriceListSettingsBasedOnDefault = $("#btnSetPriceListSettingsBasedOnDefault");

        btnSetPriceListSettingsBasedOnDefault.click(function () {
            if (parseInt(typeNode.val()) === 2) {
                let collectionCentre = collectionCentres.find(c => parseInt(c.id) === parseInt(collectionCentreNode.val()));
                if (collectionCentre) {
                    $('input[name="maturity"]').val(collectionCentre.maturity);
                    $('input[name="vat"]').val(collectionCentre.vat);
                    priceListTypeNode.val(collectionCentre.price_list_type).change();
                }
            } else if (entities.current !== null) {
                $('input[name="maturity"]').val(entities.current.maturity);
                $('input[name="vat"]').val(entities.current.vat ? entities.current.vat : null);
                priceListTypeNode.val(entities.current.price_list_type).change();
            } else {
                $('input[name="maturity"]').val(defaultMaturity);
                $('input[name="vat"]').val(defaultVAT ? defaultVAT.toFixed(2) : null);
                priceListTypeNode.val(defaultPriceListType).change();
            }
        })

        body.on('change', 'select[name="quality"]', function () {
            let id = $(this).data('id');
            let type = $(this).data('type');

            let index = data.findIndex(el => parseInt(el.id) === id && escape(el.type) === type);
            if (index !== -1) {
                data[index].quality_chosen = parseInt($(this).val());
            }

            index = items.findIndex(el => parseInt(el.id) === id && escape(el.type) === type);
            if (index !== -1) {
                items[index].quality_chosen = parseInt($(this).val());
            }

             itemsTable.api().cells().invalidate().draw();
        })

        // Items_item table
        let itemsItemTable = $("#items_itemTable").DataTable();
        $("#addItems_item").on('shown.bs.modal', function () {
            itemsItemTable.api().columns.adjust().responsive.recalc()
        })

        body.on('change', '#addItems_item input[name="quantity"]', function () {
            let row = $(this).closest('tr');
            if (row.hasClass('child')) {
                row = row.prev('tr');
            }

            if (!row.hasClass('fw-bold') && $(this).val().length !== 0) {
                row.addClass('fw-bold');
            }

            if (row.hasClass('fw-bold') && $(this).val().length === 0) {
                row.removeClass('fw-bold');
            }
        })

        $("#btnAddItems_items").click(function () {
            let inputs = itemsItemTable.$('input[name="quantity"]');

            for (let input of inputs) {
                input = $(input);
                let value = input.val();

                if (value === '' || parseFloat(value) === 0) {
                    continue;
                }

                let id = parseInt(input.data('id'));

                let index = itemsData.findIndex(el => parseInt(el.id) === id);
                if (index !== -1) {
                    itemsData[index].quantity = parseFloat(value);

                    let item = {...itemsData[index]};
                    item.uuid = uuid();

                    items = [...items, item];
                }
            }

            closeModal($(this).closest('.modal'));
            reloadItemsTable();

            for (let input of inputs) {
                input = $(input);
                input.val('').change();
            }
        })

        // Dodawanie nowego artykułu
        handleApiForm($('form#addItem'), ({response, form}) => {
            let item = response.data.item;
            itemsData = [...itemsData, item];

            let row = $(`
                <tr data-id="${item.id}">
                    <td class="item__name">${item.name}</td>
                    <td class="item__unit">${item.unit}</td>
                    <td class="item__price">${item.price}</td>
                    <td class="item__vat">${item.vat ?? ''}</td>
                    <td class="item__code">${item.code ?? ''}</td>
                    <td>
                        <input data-id="${item.id}" data-type="${item.type}" type="number"
                               name="quantity" min="1" class="form-control form-control-sm"/>
                    </td>
                    <td>
                        <button class="btn btn-sm btn-primary btnEditItemsItem" type="button" data-id="${item.id}">
                            Edytuj
                        </button>
                    </td>
                </tr>
            `)

            itemsItemTable.api().rows.add(row).draw(false);

            closeModal($('form#addItem').closest('.modal'));
            emptyForm(form);

            toastAlert('Pomyślnie dodano artykuł');
        })

        // Edytowanie artykułów
        body.on('click', '.btnEditItemsItem', function () {
            let form = $('#editItem');
            let id = $(this).data('id');

            let item = itemsData.find(i => parseInt(i.id) === parseInt(id));
            form.attr('action', url(`api/reckonings/items/${id}/edit`));

            emptyForm(form);
            fillFormInputs(form, item);
            openModal($("#editItemModal"));
        })

        handleApiForm($('form#editItem'), ({response, form}) => {
            let newItemData = response.data.item;
            let index = itemsData.findIndex(i => parseInt(i.id) === parseInt(newItemData.id));

            if (index !== -1) {
                itemsData[index] = newItemData;
            }

            let chosen = items.filter(el => parseInt(el.id) === parseInt(newItemData.id) && el.type === Constants.ITEM_TYPE_ITEM);
            for (let item of chosen) {
                let idx = items.findIndex(el => el.uuid === item.uuid);
                items[idx] = {...item, ...newItemData};
            }

            let row = itemsItemTable.$(`tr[data-id="${newItemData.id}"]`);
            let rowIndex = itemsItemTable.api().row(row).index();

            itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_NAME_INDEX).data(newItemData.name);
            itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_UNIT_INDEX).data(newItemData.unit);
            itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_PRICE_INDEX).data(newItemData.price);
            itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_VAT_INDEX).data(newItemData.vat ?? '');
            itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_CODE_INDEX).data(newItemData.code ?? '');
            itemsItemTable.api().draw(false);

            closeModal($('form#editItem').closest('.modal'));
            emptyForm(form);

            reloadItemsTable();
            toastAlert('Pomyślnie edytowano artykuł');
        }, null, err => console.log(err))

        // Edycja zwierzyny
        $('#editAnimal [name="animal_intended_use_id"]').change(function () {
            let form = $(this).closest('form');

            if (parseInt($(this).val()) === 1) {
                showField(form, 'collection_centre_id');
                showField(form, 'number_mp');
            } else {
                hideField(form, 'collection_centre_id');
                hideField(form, 'number_mp')
            }
        })

        let currentlyEditedAnimal = null;
        body.on('click', '.btnEditAnimal', function () {
            let id = $(this).data('id');
            let type = $(this).data('type');
            let animal = data.find(el => parseInt(el.id) === parseInt(id) && el.type === type);

            if (!animal) {
                return;
            }

            currentlyEditedAnimal = animal;

            let form = $('form#editAnimal');

            if (parseInt(animal.is_big) === 0) {
                hideField(form, 'weight');
            } else {
                showField(form, 'weight');
            }

            openModal(form.closest('.modal'));
            fillFormInputs(form, {
                animal: animal.name,
                weight: animal.weight,
                identifier: animal.identifier,
                identifier_district_veterinarian: animal.identifier_district_veterinarian,
                identifier_direct_sale: animal.identifier_direct_sale,
                animal_intended_use_id: animal.intended_use,
                collection_centre_id: animal.collection_centre_id,
                number_mp: animal.number_mp,
                id: animal.id,
                type: animal.type
            })

            form.find('[name="animal_intended_use_id"]').trigger('change');
        })

        handleApiForm($('form#editAnimal'), ({response, form}) => {
            let animal = response.data.animal;

            let index = data.findIndex(el => parseInt(el.id) === parseInt(currentlyEditedAnimal.id) && el.type === currentlyEditedAnimal.type);
            if (index !== -1) {
                data[index].weight = animal.weight;
                data[index].identifier = animal.identifier;
                data[index].collection_centre_id = animal.collection_centre_id;
                data[index].number_mp = animal.number_mp;
                data[index].intended_use = animal.animal_intended_use_id;
                data[index].identifier_district_veterinarian = animal.identifier_district_veterinarian;
                data[index].identifier_direct_sale = animal.identifier_direct_sale;
                data[index].collection_centre = animal.centre ? animal.centre.name : null;
            }

            reloadAnimalsTable();
            closeModal(form.closest('.modal'));

            updateCarcassesLeft();
            toastAlert('Pomyślnie edytowano zwierzynę');
        });

        userNode.change(async function () {
            let result = true;

            let value = $(this).val();
            if (
                (value.startsWith('entity-')) ||
                (!value.startsWith('entity-') && userId.startsWith('entity-'))
            ) {
                result = await confirmModalCheckDisabledItems('Zmiana rodzaju nabywcy spowoduje usunięcie niektórych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
            }

            if (result) {
                userId = $(this).val();
                reloadAnimalsTable();
                reloadItemsTable();
            } else {
                $(this).val(userId);
            }

            userChanged = true;
        })

        async function confirmModalCheckDisabledItems(message, modalOptions = {}) {
            let result = true;

            let disabledItems = items.filter(r => !canItemBeSelected(r).result);
            if (disabledItems.length > 0) {
                result = await confirmModal(message, modalOptions);
                if (result) {
                    items = items.filter(r => disabledItems.findIndex(d => parseInt(d.id) === parseInt(r.id) && d.type === r.type) === -1);
                }
            }

            return result;
        }

        async function entitiesDataUpdated() {
            reloadAnimalsTable();
            await confirmModalCheckDisabledItems('Cennik podmiotu uległ zmianie, niektóre wybrane pozycje zostaną usunięte', {
                buttons: [
                    {
                        text: 'Ok',
                        color: 'warning',
                        type: 'resolve'
                    },
                ]
            })
            reloadItemsTable();
        }

        let invoiceNumberInput = $('#addInvoice_number');
        let startingIndexInput = $('#addInvoice_starting_index');
        let currentInvoicesCount = parseInt(window._currentInvoicesCount) ?? 0;
        let season_addon = window._season_addon ?? '';
        let numbering_mode_1 = $('#addInvoice_numbering_mode_1');
        let numbering_mode_2 = $('#addInvoice_numbering_mode_2');

        changeInvoiceNumber()
        numbering_mode_1.attr('checked', true);

        numbering_mode_1.change(function(){
            invoiceNumberInput.attr('readonly', true);
            startingIndexInput.parent().parent().show();
            changeInvoiceNumber();
        })

        numbering_mode_2.change(function(){
            invoiceNumberInput.attr('readonly', false);
            startingIndexInput.parent().parent().hide();
        })

        startingIndexInput.change(function(){
            changeInvoiceNumber();
        })

        function changeInvoiceNumber(){

            let new_index;

            if(isNaN(parseInt(startingIndexInput.val()))){
                startingIndexInput.val(0);
            }
            new_index = currentInvoicesCount + parseInt(startingIndexInput.val());

            invoiceNumberInput.val(new_index + '/' + season_addon);
        }

    }

    const isAutoGenerated = (number) => {
        const regex = /^[0-9]*\/[0-9]{4}$/;
        return number.match(regex);
    }

    function naturalInvoiceSort(a, b, html) {
        if(isAutoGenerated(a) && isAutoGenerated(b)) {
            let yearA = a.split('/')[1]
            let yearB = b.split('/')[1]

            if(yearA === yearB) {
                return naturalSort(a, b, html);
            }

            return parseInt(yearA) - parseInt(yearB);
        }

        return naturalSort(a, b, html);
    }

    jQuery.extend( jQuery.fn.dataTableExt.oSort, {
        "natural_invoice-asc": function ( a, b ) {
            return naturalInvoiceSort(a,b,true);
        },

        "natural_invoice-desc": function ( a, b ) {
            return naturalInvoiceSort(a,b,true) * -1;
        },

        "natural_invoice-nohtml-asc": function( a, b ) {
            return naturalInvoiceSort(a,b,false);
        },

        "natural_invoice-nohtml-desc": function( a, b ) {
            return naturalInvoiceSort(a,b,false) * -1;
        },

        "natural_invoice-ci-asc": function( a, b ) {
            a = a.toString().toLowerCase();
            b = b.toString().toLowerCase();

            return naturalInvoiceSort(a,b,true);
        },

        "natural_invoice-ci-desc": function( a, b ) {
            a = a.toString().toLowerCase();
            b = b.toString().toLowerCase();

            return naturalInvoiceSort(a,b,true) * -1;
        }
    } );

    if (pathIs('/app/reckonings/invoices')) {
        const body = $('body');
        let invoicesTableNode = $("#invoicesTable");

        let invoicesTable = invoicesTableNode.DataTable({
            stateSave: false,
            order: [0, 'desc'],
            columnDefs: [
                {
                    targets: 0,
                    'type': 'natural_invoice'
                },
            ],
            drawCallback: function () {
                this.$('.payment-status-tooltip').each(function () {
                    new bootstrap.Tooltip(this, {html: true});
                })
            },
            filters: {
                columns: [
                    {
                        index: 6,
                        title: 'Opłacona',
                        values: [
                            {
                                text: 'Tak',
                                value: 'Tak',
                                custom: (settings, data) => {
                                    data = data[6];

                                    if(typeof data == 'undefined'){
                                        return true;
                                    }

                                    if (data.includes('Tak')){
                                        return true;
                                    }
                                }
                            },
                            {
                                text: 'Nie',
                                value: 'Nie',
                                custom: (settings, data) => {
                                    data = data[6];

                                    if(typeof data == 'undefined'){
                                        return true;
                                    }

                                    if (data.includes('Nie')) {
                                        return true;
                                    }
                                }
                            }]
                    }
                ]
            }
        });
        let invoicesTableApi = invoicesTable.api();

        invoicesTableNode.on('responsive-display.dt', function (e, dt, row) {
            $(row.node()).next('.child').find('.payment-status-tooltip').each(function () {
                new bootstrap.Tooltip(this, {html: true});
            })
        })

        $('.payment-status-tooltip').each(function () {
            new bootstrap.Tooltip(this, {html: true});
        })

        const INVOICES_PAYMENT_STATUS_CHANGE_DATE_INDEX = 6;
        const INVOICES_ACTION_INDEX = 7;

        let iframe = $('iframe');

        const setHeight = (iframe, spinner, counter = 0) => {
            let height = iframe.contentWindow.document.body.scrollHeight;

            if(counter > 50) {
                iframe.style.height = 'initial';
                spinner.destroy();
            }

            if(height === 0) {
                setTimeout(() => {
                    setHeight(iframe, spinner, counter++)
                }, 50)
            } else {
                iframe.style.height = height + 'px';
                spinner.destroy();
            }
        }

        body.on('click', '.btnDetails', async function () {
            let modalNode = $("#detailsModal");
            let modalInstance = bootstrap.Modal.getInstance(modalNode[0]) ?? new bootstrap.Modal(modalNode[0]);
            let id = $(this).data('id');
            let number = $(this).data('number');

            let spinner = new Spinner();
            iframe.height(0);

            modalNode.find('.number').text(number);
            iframe[0].src = url(`app/reckonings/invoices/${id}`);

            iframe.on('load', function () {
                setHeight(this, spinner);
                iframe.off('load');
            })

            modalInstance.show();
        })

        body.on('click', '.btnChangePaymentStatus', async function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');
            if (row.hasClass('child')) {
                row = row.prev('tr');
            }

            let spinner = new Spinner();
            try {

                let response = await axios.post(url(`api/reckonings/invoices/${id}/change-payment-status`));
                if (response.status !== 200) {
                    throw new Error();
                }

                let rowIndex = invoicesTableApi.row(row).index();
                let cell = invoicesTableApi.cell(rowIndex, INVOICES_PAYMENT_STATUS_CHANGE_DATE_INDEX);

                let actionCell = invoicesTableApi.cell(rowIndex, INVOICES_ACTION_INDEX).node();

                let date = response.data.payment_status_change_date;
                if (date) {
                    $(actionCell).find('.btnChangePaymentStatus').removeClass('btn-primary');
                    $(actionCell).find('.btnChangePaymentStatus').addClass('btn-secondary');

                    let span = $(cell.data());
                    span.text('Tak');
                    span.attr('title', `Data zmiany statusu:<br />${moment(date).formatPHP('d/m/Y H:i')}`);

                    cell.data(span.prop('outerHTML'));
                } else {
                    $(actionCell).find('.btnChangePaymentStatus').removeClass('btn-secondary');
                    $(actionCell).find('.btnChangePaymentStatus').addClass('btn-primary');

                    let span = $(cell.data());
                    span.text('Nie');
                    span.attr('title', '');
                    span.attr('data-bs-original-title', '');

                    cell.data(span.prop('outerHTML'));
                }

                invoicesTableApi.cell(rowIndex, INVOICES_ACTION_INDEX).data(actionCell[0]);
                invoicesTableApi.rows().invalidate();

                invoicesTableApi.rows().draw(false);
                spinner.destroy();

                toastAlert('Pomyślnie zmieniono status płatności faktury');
            } catch (err) {
                toastAlert('Nie udało się zmienić statusu płatności', {type: 'danger'})
                spinner.destroy();
            }
        })

        body.on('click', '.btnPreviewEmails', function () {
            let data = $(this).data('emails');
            let modal = $('#emailsModal');
            let modalBody = modal.find('.modal-body');

            let table = $(`
                <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                        <th>Data wysłania</th>
                        <th>Data pobrania faktury</th>
                        <th>Status</th>
                        <th>Odbiorca</th>
                        <th>Akcja</th>
                    </tr>
                    </thead>
                </table>
            `)

            let tbody = $(`<tbody></tbody>`);
            table.append(tbody);

            for (let email of data) {
                let row = $(`<tr></tr>`);
                let status = '';
                switch (parseInt(email.status)) {
                    case 1:
                        status = 'w kolejce';
                        break;
                    case 2:
                        status = 'wysłana';
                        break;
                    case 3:
                        status = 'błąd';
                        break;
                }

                row.append(`<td>${moment(email.created_at).formatPHP('d/m/Y H:i:s')}</td>`)
                row.append(`<td>${email.pdf_download_date ? moment(email.pdf_download_date).formatPHP('d/m/Y H:i:s') : '-'}</td>`)
                row.append(`<td>${status}</td>`)
                row.append(`<td>${email.email} ${email.name ? `(${email.name})` : ''}</td>`)
                if(email.pdf_filename) {
                    row.append(`
                        <td>
                            <a target="_blank" class="btn btn-primary btn-sm mb-1" href="${url(`app/reckonings/invoices/${email.invoice_id}/emails/${email.id}`)}">Podgląd</a>
                            <button class="btn btn-danger btn-sm mb-1 btnDeleteInvoiceEmail" data-id="${email.invoice_id}" data-email_id="${email.id}">Usuń</button>
                        </td>
                    `)
                } else {
                    row.append(`<td>-</td>`)
                }

                tbody.append(row);
            }

            table.DataTable();
            modalBody.html(table);
            openModal(modal);
        })

        body.on('click', '.btnSendInvoiceCustom', function() {
            let modal = $('#sendInvoiceCustomModal');
            let form = modal.find('form');

            form.attr('action', url(`app/reckonings/invoices/${$(this).data('id')}/send`));

            form.find('input[name="name"]').val($(this).data('name'));
            form.find('input[name="email"]').val($(this).data('email'));

            openModal(modal);
        })

        body.on('click', '.btnDeleteInvoiceEmail', async function() {
            if(await confirmModal('Czy na pewno chcesz usunąć wysłaną fakturę? Usunięty zostanie jedynie plik z fakturą. Wiadomość pozostanie w skrzynce odbiorcy.', {color: 'danger'})) {
                let form = $("#deleteInvoiceEmailForm");
                form.attr('action', url(`app/reckonings/invoices/${$(this).data('id')}/emails/${$(this).data('email_id')}/delete`));
                form.submit();
            }
        })

    }
}
